module.exports = __webpack_public_path__ + "static/media/temperature-minus.50f946da.svg";